import { render, staticRenderFns } from "./SettingsIndividualExtra.vue?vue&type=template&id=c7ed9acc&scoped=true&"
import script from "./SettingsIndividualExtra.vue?vue&type=script&lang=js&"
export * from "./SettingsIndividualExtra.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndividualExtra.vue?vue&type=style&index=0&id=c7ed9acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ed9acc",
  null
  
)

export default component.exports